import Component from "@ember/component";
import { classNames, tagName } from "@ember-decorators/component";

@tagName("div")
@classNames("discourse-root")
export default class DiscourseRoot extends Component {}
